import { progressService } from "@/services";
import { useQuery } from "@tanstack/react-query";
import { qk } from "./queryKeys";

/**
 * Every fetch is audited server-side as `member.viewed`, so these deliberately
 * do NOT refetch on window focus — an admin leaving a tab open shouldn't
 * manufacture a trail of views they never made. Same reasoning as useUsage.
 */
const AUDITED = { refetchOnWindowFocus: false, staleTime: 60_000 } as const;

export function useOrgProgress() {
	return useQuery({
		queryKey: qk.progress,
		queryFn: ({ signal }) => progressService.org(signal),
		...AUDITED,
	});
}

export function useMemberProgress(memberId: string | null) {
	return useQuery({
		queryKey: qk.memberProgress(memberId ?? ""),
		queryFn: ({ signal }) => progressService.member(memberId as string, signal),
		enabled: Boolean(memberId),
		...AUDITED,
	});
}

export function useDomainDetail(
	memberId: string | null,
	domain: string | null,
) {
	return useQuery({
		queryKey: qk.domainDetail(memberId ?? "", domain ?? ""),
		queryFn: ({ signal }) =>
			progressService.domain(memberId as string, domain as string, signal),
		enabled: Boolean(memberId && domain),
		...AUDITED,
	});
}
